import React from "react";
import { useState } from "react";
import { RiArrowDownSFill } from "react-icons/ri";
import "../css/arrival.css";
import { colorData } from "../rawData/MenuData";


const ColorList = () => {
  
  const [searchterm, setsearchterm] = useState("");
  
  return (
    <>
      <div className="sideBox">
        <ul className="border-top ">
          <button
            className="brandbtn"
            type="button"
            data-toggle="collapse"
            data-target="#color"
          >
            Colors <RiArrowDownSFill />
          </button>
          <div id="color" class="collapse show">
            <form>
              <div class="form-group">
                {/* <span className="small float-right">{colorData.length} colors</span> */}
                <input
                  type="text"
                  placeholder="Search color.."
                  className="form-control"
                  value={searchterm}
                  onChange={(event) => {
                    setsearchterm(event.target.value);
                  }}
                />
              </div>
              <div>
                <ul className="scroll-control">
                  {colorData
                    .filter((val) => {
                      if (searchterm == "") {
                        return val;
                      } else if (val.name.toLowerCase().includes(searchterm.toLowerCase())) 
                      {
                        return val;
                      }
                    })
                    .map((val) => (
                      <li>
                        <a>
                          <img src={val.image} className="colorImg" />
                          <span className="pl-2">{val.name} </span>
                          {/* <input
                                    type="checkbox"
                                    className="float-right"
                                  /> */}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </form>
          </div>
        </ul>
      </div>
    </>
  );
};

export default ColorList;
